/** Shared with StoreFilters / StoreFilterSidebar — keep in sync with catalog filters. */
export const STORE_CATEGORIES = [
  'All Categories',
  'MMO',
  'RPG',
  'Strategy',
  'Action',
  'Casual',
  'Simulation',
  'Social',
  'Metaverse',
  'Virtual World',
] as const;

export const STORE_TAGS = [
  'All Tags',
  'Collectibles',
  'PvP',
  'PvE',
  'Free-to-Play',
  'Multiplayer',
  'Browser-Based',
  'Turn-Based',
] as const;
